import Vue from 'vue';

Vue.mixin({
    methods: {
        _size(...args) {
            return _.size(...args);
        },
        _find(...args) {
            return _.find(...args);
        },
        _findIndex(...args) {
            return _.findIndex(...args);
        },
        _includes(...args) {
            return _.includes(...args);
        },
        moment(...args) {
            return moment(...args);
        },
        nl2br(str, is_xhtml) {
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        }
    }
});
